import messages from '../../assets/bh-messages.json';

const emptyContract = {
    id: '',
    owner: '',
    name: '',
    type: 'Unknown',
    difficulty: 'Unknown',
    reward: 'Unknown',
    expiration_y: null,
    expiration_d: null,
    network: '',
    notes: '',
    scans: [],
    locations: []
}


const difficulties = [
    "Daunting",
    "Challenging",
    "Standard",
    "Easy",
    "Trivial",
    'Unknown'
]
const contractType = ['Unknown', 'Kill', 'Rescue'];
const rewards = ['Unknown', 'Credits', 'DC', 'Beskar'];

const distances = ['Short', "Medium", "Long", "Very Distant", "Unknown", "Lock"];
const directions = ['N', 'NE', 'E', 'SE', 'S', 'SW', 'W', 'NW'];

const shieldedStatus = ['Unknown', 'Open', 'Shielded'];

const getMessage = type => {
    if(typeof messages[type] !== 'undefined') {
        let rand = Math.floor(Math.random()*messages[type].length)
        return messages[type][rand];
    } else {
        return '';
    }
}


export {emptyContract, difficulties, contractType, distances, directions, rewards, shieldedStatus, getMessage};
